import type { CourseCardItem } from '../types/course-card';
import { formatCourseCardCurrency, getCourseCardPriceParts } from '../lib/course-card-formatters';
import { CourseCardDealIcon } from './CourseCardDealIcon';
import { CourseCardDiscountBadge } from './CourseCardDiscountBadge';

interface CourseCardPriceProps {
  course: CourseCardItem;
  label?: string;
  cyberActive?: boolean;
}

export function CourseCardPrice({ course, label, cyberActive }: CourseCardPriceProps) {
  const hasDiscount = Boolean(course.originalPrice && course.originalPrice > course.price);
  const formattedPrice = formatCourseCardCurrency(course.price, course.currency);
  const priceParts = getCourseCardPriceParts(course.price, course.currency);

  return (
    <div className={label ? 'space-y-1.5' : undefined}>
      {label ? <p className="text-muted-text text-[0.68rem] font-bold">{label}</p> : null}
      <div className="flex flex-wrap items-baseline gap-x-2 gap-y-0.5">
        <CourseCardDealIcon
          cyberActive={cyberActive}
          flashDeal={course.flashDeal}
          hasDiscount={hasDiscount}
        />
        <span
          aria-label={formattedPrice}
          className="text-navy inline-flex items-baseline gap-1.5 leading-none tracking-tight"
        >
          <span className="text-[0.78rem] font-medium">{priceParts.currencyLabel}</span>
          <span className="text-[1.38rem] font-bold">{priceParts.amountLabel}</span>
        </span>
        {hasDiscount ? (
          <span className="text-muted-text text-[0.75rem] font-medium line-through">
            {formatCourseCardCurrency(course.originalPrice ?? course.price, course.currency)}
          </span>
        ) : null}
        {course.discount ? (
          <CourseCardDiscountBadge discount={course.discount} />
        ) : null}
      </div>
    </div>
  );
}
